import Vue from 'vue';
import ExhibitorRegistration from '../vue/ExhibitorRegistration.vue';

class ExhibitorRegistrationJs {
    constructor() {
        this.container = document.querySelector('.js-exhibitor-registration-container');
        if (this.container) {
            this.initExhibitorRegistration();
        }
    }

    // eslint-disable-next-line class-methods-use-this
    initExhibitorRegistration() {
        const exhibitorRegistration = new Vue({
            el: '#exhibitor-registration',
            components: { 'exhibitor-registration': ExhibitorRegistration },
        });

        return exhibitorRegistration;
    }
}

export default ExhibitorRegistrationJs;
